export class Userlogin {
	password! : string;
	login! : string;
}

